<template>
  <div class="card-paymethod">
    <!-- 是否分期 -->
    <template>
      <div v-if="installList && installList.length > 0" @click="setbyStages()" class="item-lable">
        <div style="display: flex; align-items: center">
          <div class="paymethod-icon" :class="'icon_youlinyuefu'"></div>
          <div>
            友邻月付
            <span class="interest">(免息)</span>
          </div>
        </div>
        <div class="open" v-if="openByStages"></div>
        <div class="close" v-else></div>
      </div>
    </template>
    <!-- 支付分期 -->
    <transition name="fade">
      <div class="paystages" v-if="installList.length">
        <template v-for="(item, index) in installList">
          <div
            class="flexbox paystages-item"
            :class="{
              activate: item.installmentId === installmentId,
              unmatched: item.unmatched
            }"
            :key="index"
            @click="setPaystage(item)"
            v-if="!item.unmatched && openByStages"
          >
            <div class="flexbox paystages_item_box">
              首付金额
              <span class="">¥{{ item.downPayments }}</span>
            </div>
            <div class="flexbox paystages_item_box">
              剩余总金额
              <span class="">¥{{ getInstallmentAmountByCoupon(item).stayPayNum }}</span>
            </div>
            <div class="flexbox paystages_item_box">
              分期数
              <span class="">{{ item.installmentNum }}期</span>
            </div>
            <div class="flexbox paystages_item_box">
              月付金额
              <span class="">¥{{ getInstallmentAmountByCoupon(item).couponInstallment }}</span>
            </div>
          </div>
        </template>
      </div>
    </transition>
    <div class="item-name">选择支付方式</div>
    <!-- 支付方式 -->
    <!-- v-if="item.value === 1 ? installList && installList.length > 0 : true" -->
    <div v-for="(item, index) in paymethods" :key="index">
      <div @click="setPaymethod(item)" class="item-lable">
        <div
          class="paymethod-icon"
          :class="item.icon"
          :style="item.value === paymethod ? 'opacity:1' : 'opacity:.3'"
        ></div>
        <div>{{ item.label }}</div>
        <div class="item-value">
          <iconfont :class="selectIcons[item.value === paymethod ? 1 : 0]" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getCookie } from '@/utils/common/cookie'
import { mul, sub } from '@/utils/compute-util'
import { isAlipay } from '@/utils/init/wx'
import { Toast } from 'mint-ui'
import { orderAmountReal } from '../options' // 计算订单支付金额

export default {
  name: 'CardPaymethod',
  data() {
    return {
      selectIcons: ['iconcircle', 'iconcircle-selected'],
      installmentId: 1,
      byStages: [{ label: '友邻月付', value: 1, icon: 'icon_youlinyuefu' }],
      paymethods: [{ label: '微信支付', value: 1, icon: 'icon_wechatpay' }],
      paystages: [
        { first: 104.0, next: 100, count: 4, value: 1 },
        { first: 104.0, next: 50, count: 8, vlaue: 2 }
      ]
    }
  },
  computed: {
    ...mapGetters('payment/order', [
      'paymethod', // 支付方式
      'openByStages', // 是否开启分期
      'coupon',
      'preOrder'
    ]),
    orderAmountReal,
    // 可选分期方案列表
    installList() {
      const { installList } = this.preOrder
      const { coupon } = this
      console.log('installList', installList)
      if (installList) {
        let count = installList.length
        const res = (installList || []).map(item => {
          item.unmatched = this.orderAmount < item.downPayments
          // 如果选择了优惠券，但是分期方案的useCoupon ==0，代表该方案不支持分期
          if (coupon && coupon.id && item.useCoupon == 0) {
            item.unmatched = true
            count--
          }
          // 如果选择了优惠券，但是分期方案的useCoupon ==1，继续判断 该优惠券isInstallmentUse===0 不可用于分期付款
          if (coupon && coupon.id && item.useCoupon == 1 && coupon.isInstallmentUse === 0) {
            item.unmatched = true
            count--
          }
          return item
        })
        // 如果count==0说明当前的分期选项中没有支持优惠券的 此时如果选择了优惠券 就关闭分期按钮
        if (count <= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.installmentId = 0 // 分期支付id
          this.$store.commit('payment/order/setbyStages', { openByStages: 0 })
        } else {
          const current = res.filter(item => !item.unmatched).shift()
          const { installmentId, couponInstallmentList } = current || {}
          console.log('当前选中========:', current, installmentId, couponInstallmentList)
          // 没选分期 没选优惠券
          if (!this.openByStages && (!coupon || !coupon.id)) {
            // 没选优惠券
            console.log('未选分期,未选优惠券')
            return res
          }
          // 如果已经选择了分期 然后又去选择优惠券 回来之后更新可以支持优惠券的分期方案的id
          if (this.openByStages && coupon && coupon.id) {
            // console.log('如果已经选择了分期 然后又去选择优惠券 回来之后更新可以支持优惠券的分期方案的id')
            // 新增逻辑 选中优惠券以后检查 优惠券分期列表是否有值  没有的话,提前将分期列表 置空
            if (!installmentId || !couponInstallmentList || couponInstallmentList.length === 0) {
              // 未查到分期方案,强制关闭分期
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.installmentId = 0 // 分期支付id
              this.$store.commit('payment/order/setbyStages', { openByStages: 0 })
            } else {
              // 拿到方案, 更新
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.installmentId = installmentId
              // 更新首付的值
              this.$store.commit('payment/order/setInstallment', current)
            }
          }
        }
        return res
      } else {
        return []
      }
    },
    // 当补差价后商品价格<友邻月付首付，则不可使用友邻月付
    orderAmount() {
      let amount = this.preOrder.orderAmount
      // 计算优惠券
      const { coupon } = this
      // 计算优惠券
      if (coupon.id && this.paymethod === 1) {
        const { couponDiscount: discount } = coupon
        amount = amount - discount
      }
      // 格式化
      amount = parseFloat(amount).toFixed(2)
      if (amount < 0) amount = 0
      return amount * 1
    }
  },
  created() {
    const android = getCookie('appVersionAndroid')
    const ios = getCookie('appVersioniOS')
    // 判断版本
    // 显示支付宝选项
    if (android || ios) {
      this.paymethods.push({
        label: '支付宝支付',
        value: 2,
        icon: 'icon_zhifubao'
      })
    }
    if (isAlipay()) {
      // 如果是在支付宝环境
      this.paymethods = [{ label: '支付宝支付', value: 2, icon: 'icon_zhifubao' }]
      this.$store.commit('payment/order/setPaymethod', { paymethod: 2 })
    }
  },
  methods: {
    // 是否开启分期
    setbyStages() {
      if (this.openByStages) {
        // 关闭分期
        this.installmentId = 0 // 分期支付id
        this.$store.commit('payment/order/setbyStages', { openByStages: 0 })
      } else {
        // 开启分期
        const item = this.getDefaultInstallment()
        const { coupon } = this
        // 如果当前选中的优惠券支持分期且 补差价后商品价格<友邻月付首付
        if (this.orderAmount === 0) {
          Toast('当前实付金额低于分期首付金额,无需分期支付')
          return
        }
        if (coupon.isInstallmentUse === 0) {
          Toast('当前优惠券不能用于分期')
          return
        }
        if (!item || this.orderAmount <= item.downPayments) {
          Toast('当前实付金额低于分期首付金额,无需分期支付')
          return
        }
        this.$nextTick(() => {
          // 使用支付方式
          this.$store.commit('payment/order/setbyStages', { openByStages: 1 }) // 新创建一个方法将分期与支付方式拆离
          this.setPaystage(this.getDefaultInstallment()) // 获取默认分期形式
        })
      }
    },
    // 切换支付方式
    setPaymethod(item) {
      const { value } = item
      if (item.value === this.paymethod) return // 点击的当前以选中的支付方式，无需操作
      if (value === 1) {
        // 微信支付
        this.$store.commit('payment/order/setPaymethod', { paymethod: 1 })
      } else if (value === 2) {
        // 支付宝支付
        this.$store.commit('payment/order/setPaymethod', { paymethod: 2 })
      }
    },
    // 获取使用优惠券的分期
    getInstallmentAmountByCoupon(item) {
      const { coupon } = this
      const list = item.couponInstallmentList
      if (coupon && coupon.id && list) {
        let couponInstallItem = list.find(x => x.couponId === coupon.id) || {}
        const { couponInstallment, installmentNum } = couponInstallItem
        return { couponInstallment, stayPayNum: sub(this.orderAmountReal, item.downPayments) }
      }
      const { installmentAmount, installmentNum } = item
      return { couponInstallment: installmentAmount, stayPayNum: sub(this.orderAmountReal, item.downPayments) }
    },
    getDefaultInstallment() {
      return this.installList.filter(item => !item.unmatched).shift()
    },

    // 重置支付方式
    resetPaystage() {
      const list = this.paymethods
      if (list.length) {
        this.setPaymethod(list[0])
      }
    },
    // 切换分期
    setPaystage(item) {
      // 如果没有开启分期 先开启
      if (!this.openByStages) {
        this.$store.commit('payment/order/setbyStages', { openByStages: 1 })
      }
      const openByStages = this.openByStages // 当前是否开启分期
      // 使用分期方式
      if (!item || item.unmatched) {
        return
      }
      this.$store.commit('payment/order/setbyStages', {
        openByStages,
        installment: item
      })
      this.installmentId = item.installmentId
    },
    // 支付前，检查支付条件
    selectedPaymethod() {
      // 微信 || 支付宝
      if (this.paymethod === 1 || this.paymethod === 2) {
        return true
      }
      if (this.openByStages === 1 && this.installmentId) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.card-paymethod {
  text-align: left;
  padding: 0.36rem 0.48rem;
  background-color: #fff;
  margin-bottom: 0.48rem;
  ::-webkit-scrollbar {
    display: none;
  }
  .item-name {
    color: #999999;
    font-size: 0.24rem;
    line-height: 0.4rem;
  }
  // 支付方式
  .item-lable {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.3rem 0;
    font-size: 0.28rem;
    color: #000000;
    .paymethod-icon {
      width: 0.4rem;
      height: 0.4rem;
      margin-right: 0.16rem;
      &.icon_wechatpay {
        background: url('../../../../images/payment/icon_wechatpay.png') round;
      }
      &.icon_youlinyuefu {
        background: url('../../../../images/payment/icon_youlinyuefu.png') round;
      }
      &.icon_Alipay {
        background: url('../../../../images/payment/icon_wechatpay.png') round;
      }
      &.icon_zhifubao {
        background: url('../../../../images/payment/icon_zhifubao.png') round;
      }
    }
    .open {
      width: 0.84rem;
      height: 0.48rem;
      background: url('../../../../images/icon/icon_open.png') round;
    }
    .close {
      width: 0.84rem;
      height: 0.48rem;
      background: url('../../../../images/icon/icon_close.png') round;
    }
    .item-value {
      flex: 1;
      text-align: right;
      font-size: 0.32rem;
      .iconcircle {
        font-size: 0.4rem;
        opacity: 0.4;
      }
      .iconcircle-selected {
        font-size: 0.4rem;
        color: #00b25a;
      }
    }
  }
  .interest {
    font-size: 0.28rem;
    font-weight: 400;
    color: #999;
  }
  // 分期
  .paystages {
    margin-bottom: 0.3rem;
    .paystages-item {
      flex-shrink: 0;
      font-size: 0.24rem;
      color: #666666;
      border-radius: 0.08rem;
      border: solid 1px #dddddd;
      background-color: #ffffff;
      padding: 0.22rem 0;
      margin-bottom: 5px;
      &.activate {
        border-color: #00b25a;
        background-color: #f0f7f7;
        color: #00b25a;
      }
      &.unmatched {
        border-color: #eeeeee;
        background-color: #f7f9ff;
      }
      .paystages_item_box {
        flex-direction: column;
        flex: 1;
        border-right: 1px solid #ececec;
        font-size: 0.24rem;
        &:last-child {
          border: none;
        }
        span {
          display: block;
          margin-top: 3px;
          font-size: 0.28rem;
          font-weight: 600;
          color: #00b25a;
        }
      }
    }
  }
}
</style>
